export default __webpack_public_path__ + "static/media/confused_illustration.aa51ca0d.png";